export class OrderReturnItemDto {
    public orderItemID: number;
    public orderReplacementItemID: string;
    public quantity: number;
    public orderItemDepositProductID: string;
    public orderReplacementItemDepositProductID: string = '';
}
